/**
 * "2026-10-02 09:30:15 UTC" from an ISO timestamp. A public call shows its
 * times in UTC to the second, so two readers in different zones quote the
 * same instant. An ISO string without an offset is read as UTC, as the API
 * writes it.
 */
export const formatUtcSeconds = (iso: string | null | undefined): string | null => {
  if (!iso) return null
  const withZone = /(Z|[+-]\d{2}:?\d{2})$/.test(iso) ? iso : `${iso}Z`
  const date = new Date(withZone)
  if (Number.isNaN(date.getTime())) return null
  return `${date.toISOString().slice(0, 19).replace('T', ' ')} UTC`
}
